(function () {
  const loadMoreBtns = document.querySelectorAll('.load-more-author-profile');

  if (loadMoreBtns.length === 0) {
    return;
  }

  loadMoreBtns.forEach((btn) => {
    let page = 1;
    const perPage = btn.getAttribute('data-per-page');
    const total = btn.getAttribute('data-total');
    const authorId = btn.getAttribute('data-author-id');
    const postsList = btn.closest('section')?.querySelector('.posts-list');

    if (!postsList) {
      return;
    }

    btn.addEventListener('click', function (event) {
      event.preventDefault();

      fetch(load_more_data.url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          nonce: load_more_data.nonce,
          locale: load_more_data.locale,
          page: page,
          perPage: perPage,
          total: total,
          authorId: authorId,
          action: 'more_author_articles'
        })
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.text();
        })
        .then((response) => {
          page += 1;
          postsList.insertAdjacentHTML('beforeend', response);

          if (page >= total) {
            btn.closest('.wp-block-buttons')?.remove();
          } else {
            btn.disabled = false;
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          btn.disabled = false;
        });

      btn.disabled = true;
    });
  });
})();
